import {makeStyles} from '@material-ui/core/styles'
import DateSelector from '../../1elements/Fields/DateSelector'
import {Text} from '../../1elements'

const DateRangeSelector = ({fromDate, setFromDate, toDate, setToDate, helperText, minFromDate, maxToDate}) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.dateSelectorsDiv}>
                <div className={classes.dateSelectorLabelDiv}>
                    <Text>From:</Text>
                    <DateSelector value={fromDate} onChange={setFromDate} disableFuture maxDate={toDate} minDate={minFromDate} />
                </div>
                <div className={classes.dateSelectorLabelDiv}>
                    <Text>To:</Text>
                    <DateSelector value={toDate}  onChange={setToDate} disableFuture maxDate={maxToDate} minDate={fromDate} />
                </div>
            </div>
            <Text type={'helperText'}>{helperText}</Text>
        </div>
    )
}

export default DateRangeSelector

const useStyles = makeStyles({
    root: {},
    dateSelectorsDiv: {
    },
    dateSelectorLabelDiv: {
        alignItems: 'center',
        display: 'grid',
        gridTemplateColumns: '1fr 4fr',
        maxWidth: '250px'
    }
})